import { CommonFileType, ExtendedFile, FileModel } from 'types/file.d';

export const sizeLimitValidator = (value?: CommonFileType[]): Promise<void> => {
  const MB100 = 104857600;

  if (!value || !value.length) {
    return Promise.resolve();
  }

  const invalid = value.some((v) => {
    const f = v as ExtendedFile;
    if (f.size !== undefined) {
      return f.size > MB100;
    }

    return false;
  });

  if (invalid) {
    return Promise.reject(new Error('File size exceed 100MB'));
  }

  return Promise.resolve();
};

export const convertFilesUploadDataToDto = (
  dto: any,
  filename: string,
  uploadResult: { filesList: FileModel[], name: string },
  multiple = false
) => {
  if (!multiple) {
    const { filesList } = uploadResult;
    if (filesList.length) {
      const firstFile = filesList[0];
      dto[filename] = { id: firstFile.id, url: firstFile.url };
    } else {
      dto[filename] = undefined;
    }
  } else {
    const { filesList = [] } = uploadResult;
    if (filesList.length) {
      dto[filename] = filesList.map((file) => {
        return { id: file.id, url: file.url };
      });
    }
  }
};